<footer>
    <div class="footer-container">
    
      <div class="footer-logo">
        <img src="../../../../assets/images/PuduvaiBazaar/puduvaibazaar-logo.png" alt="">
      </div>
  
     
      <div class="footer-contact">
        <h3>Contact Us</h3>
        <p>Phone: +1 234 567 890</p>
        <p>Email: example.com</p>
        <p>Address: 123 Street, City, Country</p>
      </div>
  
     
      <div class="footer-menu">
        <h3>Quick Links</h3>
        <ul>
          <li><a href="#">Home</a></li>
          <li><a href="#">About Us</a></li> 
          <li><a href="#">Contact Us</a></li>
        </ul>
      </div>
  
     
      <div class="footer-menu">
        <h3>Useful Links</h3>
        <ul>
          <li><a href="/FAQs">FAQ</a></li>
          <li><a href="/terms-and-condition">T&C</a></li>
          <li><a href="/privacy-policy">Privacy Policy</a></li>
          <li><a href="/cancellation-policy">Cancellation Policy</a></li>
          <li><a href="/shipping-and-delivery">Shipping & Delivery</a></li>
          <li><a href="/return-policy">Return & Exchanges</a></li>
        </ul>
      </div>
      <div class="footer-social">
        <h3>Social Media</h3>
        <ul>
          <li><a href="https://www.facebook.com/shopatpuduvaibazaar" style="padding:9px 12px 6px 13px; background: #ffffff; border-radius: 50%; margin-left: 10px;">
            <i class="fab fa-facebook-f"></i> 
          </a></li>
          <li><a href="https://twitter.com/i/flow/login" style="padding:10px 9px 6px 11px; background: #ffffff; border-radius: 50%; margin-left: 10px;">
            <i class="fab fa-twitter"></i> 
          </a></li>
          <li><a href="https://in.linkedin.com" style="padding:11px 11px 6px 13px; background: #ffffff; border-radius: 50%; margin-left: 10px;">
            <i class="fab fa-linkedin"></i>
          </a></li>
          <li><a href="https://www.instagram.com/shopatpuduvaibazaar/?hl=en" style="padding:11px 11px 6px 12px; background: #ffffff; border-radius: 50%; margin-left: 10px;">
            <i class="fab fa-instagram"></i>
          </a></li>
          <li><a href="#" style="padding:12px 13px 7px 10px; background: #ffffff; border-radius: 50%; margin-left: 10px;">
            <i class="fab fa-pinterest"></i>
          </a></li>
        </ul>
      </div>
    </div>
  </footer>